import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";

import { type EducationStep } from "./EducationFlowContainer";

export interface EducationAnalyticsPayload extends Record<string, unknown> {
  shiftId: string;
  shiftOfferId?: string;
  workerId: string;
  action: "viewed" | "back" | "confirmed";
}
const selectAnalyticsEventForStep = (step: EducationStep): string => {
  switch (step) {
    case "intro": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_INTRO;
    }

    case "your-score": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_YOUR_SCORE;
    }

    case "higher-score-is-better": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_HIGHER_SCORE_IS_BETTER;
    }

    case "earn-points": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_EARN_POINTS;
    }

    case "life-happens": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_LIFE_HAPPENS;
    }

    case "arrive-on-time": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_ARRIVE_ON_TIME;
    }

    case "start-recap": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_START_RECAP;
    }

    case "recap-first": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_RECAP_FIRST;
    }

    case "recap-second": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_RECAP_SECOND;
    }

    case "recap-third": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_RECAP_THIRD;
    }

    case "final-confirm": {
      return APP_V2_USER_EVENTS.CLIPBOARD_SCORE_EDUCATION_FINAL_CONFIRM;
    }

    default: {
      return "";
    }
  }
};

export function logCSEducationFlowStep(step: EducationStep, payload: EducationAnalyticsPayload) {
  const event = selectAnalyticsEventForStep(step);
  logEvent(event, payload);
}

export function setNextEducationStep(
  step: EducationStep,
  payload: EducationAnalyticsPayload,
  setStep: (step: EducationStep) => void
) {
  const event = selectAnalyticsEventForStep(step);
  logEvent(event, payload);
  setStep(step);
}

export function setPreviousEducationStep(
  currentStep: EducationStep,
  previousStep: EducationStep,
  payload: EducationAnalyticsPayload,
  setStep: (step: EducationStep) => void
) {
  const event = selectAnalyticsEventForStep(currentStep);
  const segmentEventPayload = {
    ...payload,
    action: "back",
  };

  logEvent(event, segmentEventPayload);
  setStep(previousStep);
}
